import { traverseParents } from 'OK/utils/dom';
import PositionManager from 'OK/menu/dropdown/PositionManager';
import ClickWorker from 'OK/menu/dropdown/triggerEventWorker/Click';
import MouseEnterWorker from 'OK/menu/dropdown/triggerEventWorker/MouseEnter';
import DropDownTemplate from 'OK/menu/dropdown/DropDownTemplate';
import { create as createEvent } from 'OK/EventFactory';

var CLASS_HIDDEN             = 'sc-menu__hidden',
    TRIGGER_EVENT_NONE       = 'none',
    TRIGGER_EVENT_CLICK      = 'click',
    TRIGGER_EVENT_MOUSEENTER = 'mouseenter',
    TIMEOUT_FOR_VIEW         = 500,
    TIMEOUT_FOR_HIDE         = 250,
    activeInstance;

class DropdownMenu {
    constructor(options) {

        this.options = {
            noarrow: "0",
            triggerEvent: TRIGGER_EVENT_MOUSEENTER,
            timeoutForShow: TIMEOUT_FOR_VIEW,
            timeoutForHide: TIMEOUT_FOR_HIDE,
            trigger: false,
            triggerActiveCls: false,
            orientation: PositionManager.ORIENTATION_B,
            align: PositionManager.ALIGN_CENTER,
            margin: 0,
            vmargin: 0,
            elCls: [],
            hiddenCls: CLASS_HIDDEN,
            activeCls: false,
            target: 'default',
            usePropagate: false,
            hideOnBodyClick: false
        };

        this._position = new PositionManager(this);

        /**
         * @type {boolean}
         */
        this._disabled = false;

        if ((arguments.length === 1) && options) {
            this._initOptions(options);
        }

        /**
         * @type {OkEvent}
         */
        this.onBeforeShow = createEvent();

        /**
         * @type {OkEvent}
         */
        this.onShow = createEvent();

        /**
         * @type {OkEvent}
         */
        this.onHide = createEvent();

    }

    _initOptions(options) {
        Object.assign(this.options, options);
    }

    activate(el) {

        if (!el) {
            el = DropDownTemplate(this.options.elCls);
        }

        /**
         * @type {Element}
         */
        this._el = el;

        /**
         * @type {Element}
         */
        this._arrowEl = el.querySelector('.sc-menu_arw_w');

        this._initOptions(el.dataset);

        var options = this.options;

        switch (options.target) {
            case 'parent':
                this._targetEl = el.parentNode;
                break;
            default:
                this._targetEl = document.getElementById('mainContainer');
                if (this._targetEl === null) {
                    this._targetEl = document.getElementById('middleColumn');
                }
                break;
        }

        if (options.trigger instanceof Node) {
            this._triggerEl = options.trigger;
        } else {
            /**
             * @type {Element}
             */
            this._triggerEl = options.trigger ? document.querySelector(options.trigger) : el.parentNode;
        }

        switch (options.triggerEvent) {
            case TRIGGER_EVENT_CLICK:
                this._triggerEventWorker = new ClickWorker(this);
                break;
            case TRIGGER_EVENT_NONE:
                break;
            default:
                this._triggerEventWorker = new MouseEnterWorker(this);
                break;
        }

        if (options.hideOnBodyClick) {
            this.onBodyClick = this.onBodyClick.bind(this);
            document.body.addEventListener('click', this.onBodyClick, true);
        }

    }

    deactivate() {
        this.destroy();
    }

    destroy() {
        this._position.destroy();
        if (this._triggerEventWorker) {
            this._triggerEventWorker.destroy();
        }

        if (this._el.parentNode) {
            this._el.parentNode.removeChild(this._el);
        }

        if (this.options.hideOnBodyClick) {
            document.body.removeEventListener('click', this.onBodyClick, true);
        }

        OK.util.clean(this);
    }

    toogle() {
        if (this._visible) {
            this.hide();
        } else {
            this.show();
        }
    }

    show() {

        if (this._visible) {
            return;
        }

        this.onBeforeShow.trigger();

        var disabled = this._disabled;
        if (disabled) {
            return;
        }

        var triggerActiveClass = this.options.triggerActiveCls;

        if (triggerActiveClass) {
            this._triggerEl.classList.add(triggerActiveClass);
        }

        this._visible = true;

        this._position.fixParent();

        if (this.options.hiddenCls) {
            this._el.classList.remove(this.options.hiddenCls);
        } else {
            this._el.classList.add(this.options.activeCls);
        }

        this._el.style.minWidth = (this._triggerEl.offsetWidth - (this.options.margin * 2)) + 'px';

        this.fixPosition();

        if (activeInstance && (activeInstance !== this)) {
            activeInstance.hide();
        }

        activeInstance = this;

        this.onShow.trigger();
    }

    getCurrentPosition() {
        return this.currentPosition;
    }

    isVisible() {
        return this._visible;
    }

    hide() {

        if (!this._visible) {
            return;
        }

        var triggerActiveClass = this.options.triggerActiveCls;

        if (triggerActiveClass) {
            this._triggerEl.classList.remove(triggerActiveClass);
        }

        this._visible = false;

        if (this.options.hiddenCls) {
            this._el.classList.add(this.options.hiddenCls);
        } else {
            this._el.classList.remove(this.options.activeCls);
        }

        if (activeInstance === this) {
            activeInstance = null;
        }

        this.onHide.trigger();
        this.currentPosition = null;
    }

    fixPosition() {
        this.currentPosition = this._position.fix();
        return this.currentPosition;
    }

    getEl() {
        return this._el;
    }

    getTriggerEl() {
        return this._triggerEl;
    }

    getArrowEl() {
        return this._arrowEl;
    }

    getTargetEl() {
        return this._targetEl;
    }

    onBodyClick(e) {
        var menuEl = this._el, triggerEl = this._triggerEl, isMenu = traverseParents(e.target,
            /**
             * @param {HTMLElement} element
             */
            function (element) {
                return menuEl === element || triggerEl === element;
            },
            null,
            true
        );

        if (!isMenu) {
            this.hide();
        }
    }

    disable() {
        this._disabled = true;
    }

    enabled() {
        this._disabled = false;
    }
}

export default DropdownMenu;
